import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { priceResult, sexualCheck, formatKR } from "@assets/utils/check";

const CustomTooltip = ({ active, payload, label, text }) => {
  // const newData = dayjs(label).format("YY.MM.DD");
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15,
          backgroundColor: "white",
          border: "1px solid #EEEEEF",
          borderRadius: "5px",
        }}
      >
        <div
          className="label"
          style={{
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {label === "Boy" ? "남성" : "여성"}
        </div>
        <div
          style={{
            fontSize: 14,
          }}
        >
          {text} :{" "}
          {label === "Boy"
            ? priceResult(payload[0].value)
            : priceResult(payload[1].value)}
        </div>
      </div>
    );
  }

  return null;
};

const CompareBarChart = ({ boy = 0, girl = 0, text }) => {
  const compareData = [
    {
      name: "Boy",
      boy: boy,
      girl: 0,
    },
    {
      name: "Girl",
      boy: 0,
      girl: girl,
    },
  ];
  let totalCheck =
    compareData[0].boy +
    compareData[0].girl +
    compareData[1].boy +
    compareData[1].girl;

  return (
    <Grid sx={{ width: 600, height: 400 }}>
      {totalCheck !== 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={compareData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              axisLine={true}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              tickFormatter={sexualCheck}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              tickFormatter={formatKR}
            />
            <Tooltip
              content={<CustomTooltip text={text} />}
              cursor={{ fill: "#F6F6F8" }}
            />
            {/* <Legend /> */}
            <Bar dataKey="boy" stackId="a" barSize={40} fill="#129BFF" />
            <Bar dataKey="girl" stackId="a" barSize={40} fill="#129BFF" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          <Typography sx={{ fontSize: 14, color: "#9A9A9B" }}>
            데이터 없음
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default CompareBarChart;
